$(document).ready(function () {

    $('body').css('display', 'none');

    $('body').fadeIn(300);



    $('a').click(function (event) {

        event.preventDefault();

        newLocation = this.href;

        $('body').fadeOut(300, newpage);

    });

    function newpage() {

        window.location = newLocation;

    }

});
